import React from "react";
import {ActionRow, ActionRowButton, Icon, PageHeading} from "peggirkit";
import {generateBreadcrumbs} from "../../../layout/Breadcrumbs";
import {Route} from "@/routing/Router";
import {FormattedMessage, useIntl} from "react-intl";
import {Bars3Icon} from "@heroicons/react/24/outline";
import {SetStateFn} from "@/utils/SetStateUtils";

type Props = {
    route: Route,
    setShowDetailsSection: SetStateFn<boolean>,
    isLargeScreen: boolean,
};

const JobApplicationHeading = ({route, setShowDetailsSection, isLargeScreen}: Props) => {
    const intl = useIntl();

    return (
        <PageHeading
            breadcrumbs={generateBreadcrumbs(route, intl)}
            title={route.name(intl)}
            actionRow={
                isLargeScreen ? undefined :
                    <ActionRow>
                        <ActionRowButton
                            color={"secondary"}
                            iconBefore={<Icon icon={Bars3Icon}/>}
                            buttonAction={{
                                as: "button",
                                actionProps: {
                                    onClick: e => {
                                        e.preventDefault();
                                        setShowDetailsSection(true);
                                    }
                                },
                            }}
                        >
                            <FormattedMessage id={"showDetails"}/>
                        </ActionRowButton>
                    </ActionRow>
            }
            actionRowHorizontal={false}
            breakpoints={{"2xs": {actionRowHorizontal: true}}}
        />
    );
};

export default JobApplicationHeading;